// extracted by mini-css-extract-plugin
module.exports = {"container":"Counter_container__xGy4m","count":"Counter_count__0L_X8","text":"Counter_text__lG1Jj"};